export default __webpack_public_path__ + "static/logo-b20d069790690b434ac451352c78c538.png";